import { ReportType } from '@/interfaces'
import store from '@/store'
import { computed } from 'vue'
import type { ComputedRef } from 'vue'
export interface UseReportTypeReturn {
  reportType: ComputedRef<ReportType>
  setReportType: (_reportType: ReportType) => void
}

export function useReportType(): UseReportTypeReturn {
  const reportType = computed<ReportType>(() => store.getters['cache/getReportType']())

  function setReportType(_reportType: ReportType) {
    store.dispatch('cache/setReportType', _reportType)
  }

  return {
    reportType,
    setReportType
  }
}
